// src/components/layout/Sidebar.js
import React from 'react';
import { useApp } from '../../contexts/AppContext';
import { useTheme } from '../../contexts/ThemeContext';
import { ROLE_LABELS, ROLE_COLORS } from '../../data/store';

const NAV_ITEMS = {
  admin:      [
    { id: 'dashboard', icon: '⊞', label: 'Dashboard' },
    { id: 'users',     icon: '👥', label: 'Users' },
    { id: 'clients',   icon: '🏢', label: 'Clients' },
    { id: 'trucks',    icon: '🚛', label: 'Trucks' },
    { id: 'gps',       icon: '📡', label: 'GPS Devices' },
    { id: 'gpsLoads',  icon: '📶', label: 'SIM Load Monitor' },
    { id: 'documents', icon: '📄', label: 'Documents' },
    { id: 'tracking',  icon: '🗺️', label: 'Live Tracking' },
    { id: 'geofencing',icon: '📍', label: 'Geofencing' },
    { id: 'history',   icon: '🕐', label: 'Travel History' },
    { id: 'reports',   icon: '📊', label: 'Reports' },
    { id: 'settings',  icon: '⚙️', label: 'Settings' },
  ],
  encoder:    [
    { id: 'dashboard', icon: '⊞', label: 'Dashboard' },
    { id: 'trucks',    icon: '🚛', label: 'Trucks' },
    { id: 'gps',       icon: '📡', label: 'GPS Devices' },
    { id: 'gpsLoads',  icon: '📶', label: 'SIM Load Monitor' },
    { id: 'documents', icon: '📄', label: 'Documents' },
  ],
  dispatcher: [
    { id: 'dashboard', icon: '⊞', label: 'Dashboard' },
    { id: 'trucks',    icon: '🚛', label: 'Trucks' },
    { id: 'documents', icon: '📄', label: 'Documents' },
    { id: 'tracking',  icon: '🗺️', label: 'Live Tracking' },
    { id: 'geofencing',icon: '📍', label: 'Geofencing' },
    { id: 'history',   icon: '🕐', label: 'Travel History' },
    { id: 'reports',   icon: '📊', label: 'Reports' },
  ],
  client:     [
    { id: 'my_trucks', icon: '🚛', label: 'My Fleet' },
    { id: 'live_map',  icon: '🗺️', label: 'Live Map' },
  ],
};

export default function Sidebar({ activePage, onNavigate, collapsed, onToggle, isMobileDrawer }) {
  const { currentUser, logout } = useApp();
  const { theme, toggleTheme, isDark } = useTheme();

  const navItems = (NAV_ITEMS[currentUser?.role] || []).filter(item =>
    currentUser?.modules?.includes(item.id)
  );
  const roleColor = ROLE_COLORS[currentUser?.role] || '#f97316';

  const s = {
    sidebar:    { height: '100vh', background: theme.bgSidebar, borderRight: `1px solid ${theme.border}`, display: 'flex', flexDirection: 'column', overflow: 'hidden', flexShrink: 0, position: 'sticky', top: 0, transition: 'width 0.25s ease' },
    logoRow:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 14px 12px' },
    logoWrap:   { display: 'flex', alignItems: 'center', gap: 10 },
    logoIcon:   { width: 32, height: 32, background: 'rgba(249,115,22,0.12)', border: '1px solid rgba(249,115,22,0.2)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    logoText:   { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 13, color: theme.textPrimary, letterSpacing: '-0.3px' },
    logoPro:    { fontSize: 8, fontWeight: 700, letterSpacing: 2, color: '#f97316', marginTop: -2 },
    collapseBtn:{ width: 28, height: 28, background: theme.bgHover, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.textMuted, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    userCard:   { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', margin: '0 10px', background: theme.bgHover, borderRadius: 10, border: `1px solid ${theme.border}` },
    avatar:     { width: 34, height: 34, borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 11, flexShrink: 0 },
    userName:   { fontSize: 12, fontWeight: 600, color: theme.textPrimary, fontFamily: 'Syne, sans-serif', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    nav:        { flex: 1, padding: '16px 10px', display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto' },
    navItem:    { display: 'flex', alignItems: 'center', gap: 10, padding: isMobileDrawer ? '13px 12px' : '9px 12px', borderRadius: 9, background: 'transparent', borderTop: '1px solid transparent', borderRight: '1px solid transparent', borderBottom: '1px solid transparent', color: theme.sidebarText, cursor: 'pointer', fontSize: isMobileDrawer ? 15 : 13, fontFamily: 'DM Sans, sans-serif', fontWeight: 400, width: '100%', textAlign: 'left', transition: 'all 0.15s', whiteSpace: 'nowrap', overflow: 'hidden' },
    navActive:  { background: theme.bgActive, borderTop: '1px solid rgba(249,115,22,0.12)', borderRight: '1px solid rgba(249,115,22,0.12)', borderBottom: '1px solid rgba(249,115,22,0.12)' },
    navIcon:    { fontSize: isMobileDrawer ? 18 : 16, flexShrink: 0 },
    navLabel:   { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', color: theme.sidebarActive },
    navDot:     { width: 5, height: 5, borderRadius: '50%', flexShrink: 0 },
    bottom:     { padding: '8px 10px', borderTop: `1px solid ${theme.border}`, display: 'flex', flexDirection: 'column', gap: 6 },
    themeBtn:   { display: 'flex', alignItems: 'center', gap: 10, padding: isMobileDrawer ? '12px 12px' : '8px 12px', borderRadius: 9, background: 'transparent', border: `1px solid ${theme.border}`, color: theme.textMuted, cursor: 'pointer', fontSize: isMobileDrawer ? 14 : 12, fontFamily: 'DM Sans, sans-serif', width: '100%', transition: 'all 0.15s', whiteSpace: 'nowrap' },
    logoutBtn:  { display: 'flex', alignItems: 'center', gap: 10, padding: isMobileDrawer ? '13px 12px' : '9px 12px', borderRadius: 9, background: 'transparent', border: `1px solid ${theme.border}`, color: theme.textMuted, cursor: 'pointer', fontSize: isMobileDrawer ? 15 : 13, fontFamily: 'DM Sans, sans-serif', width: '100%', transition: 'all 0.15s', whiteSpace: 'nowrap' },
  };

  return (
    <aside style={{ ...s.sidebar, width: isMobileDrawer ? 260 : (collapsed ? 64 : 230) }}>
      <div style={{ paddingBottom: 8 }}>
        <div style={s.logoRow}>
          {(!collapsed || isMobileDrawer) && (
            <div style={s.logoWrap}>
              <div style={s.logoIcon}>
                <svg width="18" height="18" viewBox="0 0 28 28" fill="none">
                  <path d="M4 20L14 8L20 15L24 10" stroke="#f97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="24" cy="10" r="2.5" fill="#f97316"/>
                </svg>
              </div>
              <div>
                <div style={s.logoText}>ShipDoTrack</div>
                <div style={s.logoPro}>FLEET MANAGEMENT</div>
              </div>
            </div>
          )}
          <button onClick={onToggle} style={s.collapseBtn} title={isMobileDrawer ? 'Close menu' : 'Toggle sidebar'}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {isMobileDrawer ? (
                <path d="M18 6L6 18M6 6l12 12" />
              ) : collapsed ? (
                <path d="M9 18l6-6-6-6"/>
              ) : (
                <path d="M15 18l-6-6 6-6"/>
              )}
            </svg>
          </button>
        </div>

        <div style={s.userCard}>
          <div style={{ ...s.avatar, background: roleColor + '22', border: `1.5px solid ${roleColor}44`, color: roleColor }}>
            {currentUser?.avatar}
          </div>
          {(!collapsed || isMobileDrawer) && (
            <div style={{ minWidth: 0 }}>
              <div style={s.userName}>{currentUser?.name}</div>
              <div style={{ fontSize: 10, fontWeight: 500, color: roleColor, marginTop: 1 }}>
                {ROLE_LABELS[currentUser?.role]}
              </div>
            </div>
          )}
        </div>
      </div>

      <nav style={s.nav}>
        {navItems.map(item => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            style={{
              ...s.navItem,
              ...(activePage === item.id ? s.navActive : {}),
              borderLeft: activePage === item.id ? `2px solid ${roleColor}` : '2px solid transparent',
            }}
            title={collapsed && !isMobileDrawer ? item.label : ''}
          >
            <span style={s.navIcon}>{item.icon}</span>
            {(!collapsed || isMobileDrawer) && <span style={{ ...s.navLabel, color: activePage === item.id ? theme.textPrimary : theme.sidebarText }}>{item.label}</span>}
            {(!collapsed || isMobileDrawer) && activePage === item.id && <span style={{ ...s.navDot, background: roleColor }} />}
          </button>
        ))}
      </nav>

      <div style={s.bottom}>
        {/* Theme toggle */}
        <button onClick={toggleTheme} style={s.themeBtn} title={collapsed && !isMobileDrawer ? (isDark ? 'Light mode' : 'Dark mode') : ''}>
          <span style={{ fontSize: 15, flexShrink: 0 }}>{isDark ? '☀️' : '🌙'}</span>
          {(!collapsed || isMobileDrawer) && <span>{isDark ? 'Light Mode' : 'Dark Mode'}</span>}
        </button>
        {/* Logout */}
        <button onClick={logout} style={s.logoutBtn} title={collapsed && !isMobileDrawer ? 'Logout' : ''}>
          <span style={{ flexShrink: 0 }}>⎋</span>
          {(!collapsed || isMobileDrawer) && <span>Sign Out</span>}
        </button>
      </div>
    </aside>
  );
}
